export default __webpack_public_path__ + "static/media/Breeches of the Shivering Stars.b6619a57.jpg";